import App from './components/app/App';
import { INTERNAL_ACCESS } from '../../global/app-global-values';
import React from 'react';

const Internal = () => <App />;

export default {
  routeProps: {
    path: '/internal',
    component: Internal,
  },
  name: 'Internal',
  label: 'Internal',
  iconClassName: 'icon-unlocked',
  active: true,
  accessGroup: INTERNAL_ACCESS,
};
